import StarRating from './star-rating.vue'

export default StarRating
